export const themesObject = {
  vs: "vs",
  "vs-dark": "vs-dark",
  dracula: "Dracula",
  monokai: "Monokai",
  "night-owl": "Night Owl",
};

export const themesNameArray = [
  "vs",
  "vs-dark",
  "dracula",
  "monokai",
  "night-owl",
];
